<h1 class="abilHeader">
  {{ header() || "" | translate }}
</h1>
<div class="howBox">
  <div class="howList">
    <div class="howIconContainer">
      <span class="howNumber">1</span
      ><img src="assets/img/how1.png" class="howIcon" />
    </div>
    <p class="abilText">
      <span class="abilBold">{{ bold1() || "" | translate }}</span
      ><br />
      {{ text1() || "" | translate }}
    </p>
  </div>
  <div class="howList">
    <div class="howIconContainer">
      <span class="howNumber">2</span
      ><img src="assets/img/how2.png" class="howIcon" />
    </div>
    <p class="abilText">
      <span class="abilBold">{{ bold2() || "" | translate }}</span
      ><br />
      {{ text2() || "" | translate }}
    </p>
  </div>
  <div class="howList">
    <div class="howIconContainer">
      <span class="howNumber">3</span
      ><img src="assets/img/how3.png" class="howIcon" />
    </div>
    <p class="abilText">
      <span class="abilBold">{{ bold3() || "" | translate }}</span
      ><br />
      {{ text3() || "" | translate }}
    </p>
  </div>
  <div class="howList">
    <div class="howIconContainer">
      <span class="howNumber">4</span
      ><img src="assets/img/how4.png" class="howIcon" />
    </div>
    <p class="abilText">
      <span class="abilBold">{{ bold4() || "" | translate }}</span
      ><br />
      {{ text4() || "" | translate }}
    </p>
  </div>
</div>
